// extracted by mini-css-extract-plugin
export default {"ladningbg":"Header_ladningbg__qhG2l"};